// @flow
import * as React from "react";
import type { Game, Opponent, Team } from "../../common/types";
import List from "@material-ui/core/List";
import ListSubheader from "@material-ui/core/ListSubheader";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import _ from "lodash";
import gameSelectors from "../../selectors/gameSelectors";
import moment from "moment";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import AdminEditModal from "./AdminEditModal";
import AdminEditGame from "./AdminEditGame";
import { Suspense } from "react";
import CreateIcon from "@material-ui/icons/Create";

type Props = {
  games: [Game],
  teams: [Team],
  opponents: [Opponent],
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      position: "relative",
    },
    listHeader: {
      backgroundColor: theme.palette.background.paper,
    },
    ul: {
      backgroundColor: "inherit",
      padding: 0,
    },
  })
);

function AdminEditGames({ games, teams, opponents, gamesRef }: Props) {
  const classes = useStyles();
  const [editModalOpen, setEditModalOpen] = React.useState(false);
  const [gameIdForAction, setgameIdForAction] = React.useState(null);
  const teamsSorted = _.sortBy(teams, ["name"]);

  return (
    <List className={classes.root} subheader={<li />}>
      {teamsSorted.map((team: Team) => (
        <li key={`section-${team.id}`}>
          <List>
            <ListSubheader className={classes.listHeader}>
              {team.name}
            </ListSubheader>
            <Suspense>
              {_.sortBy(
                gameSelectors.getGamesFilteredByTeam(games, [team.id]),
                ["date"]
              ).map((game: Game) => {
                const opponent = opponents.find(
                  (opponent: Opponent) => opponent.id === game.opponentId
                );
                if (opponent == null) {
                  return null;
                }
                return (
                  <ListItem key={`item-${team.id}-${game.id}`}>
                    <ListItemText
                      primary={opponent.name}
                      secondary={moment(game.date).format("DD.MM.YY, HH:mm")}
                    />
                    <ListItemSecondaryAction>
                      <IconButton
                        edge="end"
                        aria-label="delete"
                        onClick={async () => {
                          await setgameIdForAction(game.id);
                          setEditModalOpen(true);
                        }}
                      >
                        <CreateIcon />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })}
            </Suspense>
          </List>
        </li>
      ))}
      <AdminEditModal
        content={
          <AdminEditGame
            gameId={gameIdForAction}
            handleClose={() => {
              setEditModalOpen(false);
            }}
          />
        }
        open={editModalOpen}
        handleClose={() => {
          setEditModalOpen(false);
        }}
      />
    </List>
  );
}

export default AdminEditGames;
